// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__7hNIb","load":"styles_load__nm+Wl"};